/** @jsx jsx */
import { Box, Flex, Button, jsx } from 'theme-ui'

import { useResource } from './ResourceContainer'
import { Resources } from '../Resource'
import { DisciplineBoxes } from './DisciplineBoxes'

const resourceTabHeaders = [
  { name: 'All', slug: 'resources' },
  { name: 'Publications', slug: 'publications' },
  { name: 'Multi-media', slug: 'multiMedia' },
  { name: 'Educational materials', slug: 'educationalMaterials' },
  { name: 'Member spotlights', slug: 'memberSpotlights' },
]

const disciplines = [
  'Biology science',
  'Social science',
  'Engineering',
  'Economics',
  'Culturual antropology',
  'Security studies',
  'Traditional knowledge',
]

const Tab = ({ slug, children }: { slug: string }) => {
  const { active, setActive } = useResource()

  return (
    <Button
      onClick={() => setActive(slug)}
      sx={{
        display: 'inline',
        mr: [3],
        fontFamily: 'Futura Bold',
        fontSize: [4],
        color: '#1D1D1D',
        outline: 'none',
        cursor: 'pointer',
        border: 'none',
        backgroundColor: '#fff',
        '::after': {
          content: '" "',
          display: 'block',
          width: active === slug ? '100%' : '0%',
          height: '3px',
          background: '#147CED',
          transition: 'width .3s',
        },
      }}
    >
      {children}
    </Button>
  )
}

export const ResourceHeaderLinks = () => {
  return (
    <Flex
      sx={{
        flexDirection: ['column', 'row'],
      }}
    >
      {resourceTabHeaders.map(({ name, slug }) => (
        <Tab slug={slug} key={slug}>
          {name}
        </Tab>
      ))}
    </Flex>
  )
}

// get all content for each type of resources. They are separate nodes so we'll have a file for each?

export const ResourceTabs = () => {
  return (
    <Box>
      <ResourceHeaderLinks />
      <Box sx={{ mx: [0, 3] }}>
        <DisciplineBoxes disciplines={disciplines} />
      </Box>
      <Resources />
    </Box>
  )
}
